export default {
  PRIMARY: 'primary',
  SIMPLE: 'simple',
  SIMPLE_WITHOUT_HOMEPAGE_LINK: 'simpleWithoutLink',
  SIMPLE_WITH_PROGRESS: 'simpleWithProgress',
};
